import { URL_REPLACEMENT } from '$const';
import { get } from '~services/api/methods';

export async function getSapParameters() {
  const requestUrl = `${URL_REPLACEMENT.BACKEND_URL}/tools/web2print/sap_parameter`;
  const response = await get(requestUrl);
  return response;
}

export async function getSapDownloadUrl(documentId: number, clientId: number) {
  const requestUrl = `${URL_REPLACEMENT.SYMFONY_URL}/o2e/api/getdownloadurl/${documentId}/${clientId}`;
  const response = await get(requestUrl);
  return response;
}
